import gql from "graphql-tag";

export const STAFF_UPDATE_USER_ACTIVITY_MUTATION = gql`
  mutation staffUpdateUserActivity($data: UserActivityInput!) {
    staffUpdateUserActivity(data: $data) {
      success
      error
    }
  }
`;

export const STAFF_UPDATE_NUTRITION_LOG_MUTATION = gql`
  mutation staffUpdateNutritionLog($data: BlockNutritionLogInput!) {
    staffUpdateNutritionLog(data: $data) {
      success
      error
    }
  }
`;

export const STAFF_UPDATE_USER_REST_DAY_MUTATION = gql`
  mutation staffUpdateUserRestDay($data: UserRestDayInput!) {
    staffUpdateUserRestDay(data: $data) {
      success
      error
    }
  }
`;
